import type { AuthStoreAdapter } from '@billda/shared-ui';
import { createAuthFailureHandler } from '@billda/shared-ui';
import { useAuthStore } from '../../features/auth/stores/authStore';
import { useMultiAccountStore } from '../../features/auth/stores/multiAccountStore';

/**
 * Auth store adapter for portal.
 * Adapts portal's auth store to the shared AuthStoreAdapter interface.
 * Note: getToken() reads token from authStore, getRefreshToken() reads from multiAccountStore
 *
 * Shared between axiosClient.ts and billdaApi.ts so there is one definition of the
 * adapter and the auth-failure handler.
 */
export const authAdapter: AuthStoreAdapter = {
  getToken: () => useAuthStore.getState().token,
  getRefreshToken: () => {
    const currentAccount = useMultiAccountStore.getState().getCurrentAccount();
    const refreshToken = currentAccount?.refreshToken || null;
    console.log('[TabSync] authAdapter.getRefreshToken()', {
      currentEmail: useMultiAccountStore.getState().currentAccountEmail,
      hasAccount: !!currentAccount,
      tokenTail: refreshToken?.slice(-8),
      lastUpdatedAt: useMultiAccountStore.getState().lastUpdatedAt,
    });
    return refreshToken;
  },
  setTokens: (token, refreshToken) => {
    console.log('[TabSync] authAdapter.setTokens() called from shared layer', {
      tokenTail: refreshToken?.slice(-8),
    });
    useAuthStore.getState().setTokens({ token, refreshToken });
  },
  logout: () => useAuthStore.getState().logout(),
};

/**
 * Handle authentication failures.
 * Logs the user out and redirects to login page.
 */
export const handleAuthFailure = createAuthFailureHandler({
  appLabel: 'Portal',
  getToken: () => useAuthStore.getState().token,
  logout: reason => useAuthStore.getState().logout(reason),
});
